module.exports = __webpack_public_path__ + "static/media/exyookay-parts-online-edited.d9a9ec88.png";